module.exports = __webpack_public_path__ + "ab550eaec2295b3c1502b7afeb743a1b.png";